var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.loading,"empty":_setup.empty}},[_c('div',{staticClass:"wrapper-box"},[(_setup.activeComponent)?_c(_setup.activeComponent,{tag:"component",attrs:{"subTabList":_setup.activeModule.subTabList,"isOverview":""}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }